import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { NavigationWrapper, TabItems } from '../../ui';

type Props = React.PropsWithChildren<RouteComponentProps>;

const SecureTabs = ({ match, children }: Props): JSX.Element => {
  const { dashboardPath, mfaPath, navigationPath, oauthPath, signaturePath } = usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  const { currentProject } = useCurrentProject(projectId);

  const tabItems: TabItems = [
    {
      label: intl.formatMessage({ id: 'secure.oauth2.tab' }),
      href: oauthPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'secure.signature.tab' }),
      href: signaturePath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'secure.mfa.tab' }),
      href: mfaPath(projectId)
    }
  ];

  const breadCrumbsOptions = [
    {
      label: intl.messages['dashboard.label'],
      to: dashboardPath()
    },
    {
      label: currentProject?.name,
      to: navigationPath(projectId)
    },
    {
      label: intl.messages['navigation.settings.secure.label'],
      to: `#`
    }
  ];

  return (
    <NavigationWrapper
      breadCrumbsOptions={breadCrumbsOptions}
      tabsItems={tabItems}
      dataTestId="secure-settings">
      {children}
    </NavigationWrapper>
  );
};

export default withRouter(SecureTabs);
